import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We recommend you call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "#1-call-identify-as-soon-as-youre-able"
      }}>{`as soon as you're able`}</a>{`, typically when a user signs up or logs in.`}</p>
    <p>{`This doesn't work if one or both platforms are unauthenticated. Some examples of such cases are:`}</p>
    <ul>
      <li parentName="ul">{`Onboarding and signup flows before authentication.`}</li>
      <li parentName="ul">{`Unauthenticated web pages redirecting to authenticated mobile apps.`}</li>
      <li parentName="ul">{`Authenticated web apps prompting an app download.`}</li>
    </ul>
    <p>{`In these cases, you can use a `}<a parentName="p" {...{
        "href": "https://developer.android.com/training/app-links/deep-linking"
      }}>{`deep link`}</a>{` on Android and `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/xcode/supporting-universal-links-in-your-app"
      }}>{`universal links`}</a>{` on iOS to identify users.`}</p>
    <ol>
      <li parentName="ol">{`Use `}<inlineCode parentName="li">{`posthog.get_distinct_id()`}</inlineCode>{` to get the current distinct ID. Even if you cannot call identify because the user is unauthenticated, this will return an anonymous distinct ID generated by PostHog.`}</li>
      <li parentName="ol">{`Add the distinct ID to the deep link as query parameters, along with other properties like UTM parameters.`}</li>
      <li parentName="ol">{`When the user is redirected to the app, parse the deep link and handle the following cases:`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`The user is already authenticated on the mobile app. In this case, call `}<a parentName="li" {...{
          "href": "/docs/libraries/js/features#alias"
        }}><inlineCode parentName="a">{`posthog.alias()`}</inlineCode></a>{` with the distinct ID from the web. This associates the two distinct IDs as a single person.`}</li>
      <li parentName="ul">{`The user is unauthenticated. In this case, call `}<a parentName="li" {...{
          "href": "/docs/libraries/js/features#identifying-users"
        }}><inlineCode parentName="a">{`posthog.identify()`}</inlineCode></a>{` with the distinct ID from the web. Events will be associated with this distinct ID. `}</li>
    </ul>
    <p>{`As long as you associate the distinct IDs with `}<inlineCode parentName="p">{`posthog.identify()`}</inlineCode>{` or `}<inlineCode parentName="p">{`posthog.alias()`}</inlineCode>{`, you can track events generated across platforms.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      